export const NOTIFICATIONS = [
  {
    id: 2,
    title: 'Server maintenance scheduled',
    message:
      'Scheduled maintenance on the server will occur at 3:00 AM. Please plan accordingly.',
    to: 'pm3.3.platfoza@pec.it',
    subject: 'Settings',
    attachments: ['Image.png', '1649908528162816443.eml', '123.xlsx'],
    html: JSON.stringify(
      {
        Status: 0,
        RejectedRecipients: [],
        ApprovedRecipients: ['pm3.3.platfoza@pec.it'],
        FromRejected: false,
        GeneralErrors: [],
        AllResponses: [
          {
            EnhancedStatusCode: '2.1.0',
            Code: 250,
            Lines: ['Ok'],
            Status: 0,
            Message: 'Ok',
          },
          {
            EnhancedStatusCode: '2.1.5',
            Code: 250,
            Lines: ['Ok'],
            Status: 0,
            Message: 'Ok',
          },
          {
            EnhancedStatusCode: '2.0.0',
            Code: 250,
            Lines: ['Ok: 1954 bytes queued'],
            Status: 0,
            Message: 'Ok: 1954 bytes queued',
          },
        ],
        RejectedRecipientsErrors: {},
      },
      null,
      2
    ),
    seen: true,
    time: new Date(),
  },
  {
    id: 3,
    title: 'New message',
    message: 'You have received a new message.',
    to: 'pm3.3.platfoza@pec.it',
    subject: 'Settings',
    attachments: ['Image.png', '1649908528162816443.eml', '123.xlsx'],
    html: JSON.stringify(
      {
        Status: 0,
        RejectedRecipients: [],
        ApprovedRecipients: ['pm3.3.platfoza@pec.it'],
        FromRejected: false,
        GeneralErrors: [],
        AllResponses: [
          {
            EnhancedStatusCode: '2.1.0',
            Code: 250,
            Lines: ['Ok'],
            Status: 0,
            Message: 'Ok',
          },
          {
            EnhancedStatusCode: '2.1.5',
            Code: 250,
            Lines: ['Ok'],
            Status: 0,
            Message: 'Ok',
          },
          {
            EnhancedStatusCode: '2.0.0',
            Code: 250,
            Lines: ['Ok: 1954 bytes queued'],
            Status: 0,
            Message: 'Ok: 1954 bytes queued',
          },
        ],
        RejectedRecipientsErrors: {},
      },
      null,
      2
    ),
    seen: false,
    time: new Date(),
  },
  {
    id: 4,
    title: 'Your message has not been sent',
    message: 'Your message has not been sent',
    to: 'pm3.3.platfoza@pec.it',
    subject: 'Settings',
    attachments: ['Image.png', '1649908528162816443.eml', '123.xlsx'],
    html: JSON.stringify(
      {
        Status: 0,
        RejectedRecipients: [],
        ApprovedRecipients: ['pm3.3.platfoza@pec.it'],
        FromRejected: false,
        GeneralErrors: [],
        AllResponses: [
          {
            EnhancedStatusCode: '2.1.0',
            Code: 250,
            Lines: ['Ok'],
            Status: 0,
            Message: 'Ok',
          },
          {
            EnhancedStatusCode: '2.1.5',
            Code: 250,
            Lines: ['Ok'],
            Status: 0,
            Message: 'Ok',
          },
          {
            EnhancedStatusCode: '2.0.0',
            Code: 250,
            Lines: ['Ok: 1954 bytes queued'],
            Status: 0,
            Message: 'Ok: 1954 bytes queued',
          },
        ],
        RejectedRecipientsErrors: {},
      },
      null,
      2
    ),
    seen: true,
    time: new Date(),
  },
  {
    id: 5,
    title: 'New user tutorial available',
    message:
      'A step-by-step tutorial for new users is now available. Learn how to get started with PecManager3.',
    to: 'pm3.3.platfoza@pec.it',
    subject: 'Settings',
    attachments: ['Image.png', '1649908528162816443.eml', '123.xlsx'],
    html: JSON.stringify(
      {
        Status: 0,
        RejectedRecipients: [],
        ApprovedRecipients: ['pm3.3.platfoza@pec.it'],
        FromRejected: false,
        GeneralErrors: [],
        AllResponses: [
          {
            EnhancedStatusCode: '2.1.0',
            Code: 250,
            Lines: ['Ok'],
            Status: 0,
            Message: 'Ok',
          },
          {
            EnhancedStatusCode: '2.1.5',
            Code: 250,
            Lines: ['Ok'],
            Status: 0,
            Message: 'Ok',
          },
          {
            EnhancedStatusCode: '2.0.0',
            Code: 250,
            Lines: ['Ok: 1954 bytes queued'],
            Status: 0,
            Message: 'Ok: 1954 bytes queued',
          },
        ],
        RejectedRecipientsErrors: {},
      },
      null,
      2
    ),
    seen: false,
    time: new Date(),
  },
  {
    id: 9,
    title: 'New feature: Multi-language support',
    message:
      'We have added multi-language support. You can now switch the interface language in the settings.',
    to: 'pm3.3.platfoza@pec.it',
    subject: 'Settings',
    attachments: ['Image.png', '1649908528162816443.eml', '123.xlsx'],
    html: JSON.stringify(
      {
        Status: 0,
        RejectedRecipients: [],
        ApprovedRecipients: ['pm3.3.platfoza@pec.it'],
        FromRejected: false,
        GeneralErrors: [],
        AllResponses: [
          {
            EnhancedStatusCode: '2.1.0',
            Code: 250,
            Lines: ['Ok'],
            Status: 0,
            Message: 'Ok',
          },
          {
            EnhancedStatusCode: '2.1.5',
            Code: 250,
            Lines: ['Ok'],
            Status: 0,
            Message: 'Ok',
          },
          {
            EnhancedStatusCode: '2.0.0',
            Code: 250,
            Lines: ['Ok: 1954 bytes queued'],
            Status: 0,
            Message: 'Ok: 1954 bytes queued',
          },
        ],
        RejectedRecipientsErrors: {},
      },
      null,
      2
    ),
    seen: false,
    time: new Date(),
  },
  {
    id: 10,
    title: 'New message',
    message: 'You have received a new message.',
    to: 'pm3.3.platfoza@pec.it',
    subject: 'Settings',
    attachments: ['Image.png', '1649908528162816443.eml', '123.xlsx'],
    html: JSON.stringify(
      {
        Status: 0,
        RejectedRecipients: [],
        ApprovedRecipients: ['pm3.3.platfoza@pec.it'],
        FromRejected: false,
        GeneralErrors: [],
        AllResponses: [
          {
            EnhancedStatusCode: '2.1.0',
            Code: 250,
            Lines: ['Ok'],
            Status: 0,
            Message: 'Ok',
          },
          {
            EnhancedStatusCode: '2.1.5',
            Code: 250,
            Lines: ['Ok'],
            Status: 0,
            Message: 'Ok',
          },
          {
            EnhancedStatusCode: '2.0.0',
            Code: 250,
            Lines: ['Ok: 1954 bytes queued'],
            Status: 0,
            Message: 'Ok: 1954 bytes queued',
          },
        ],
        RejectedRecipientsErrors: {},
      },
      null,
      2
    ),
    seen: false,
    time: new Date(),
  },
];
